/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { axiosInstance } from '../axiosInstance'
export const getRouterAllUsers = param => {
    try {
        return axiosInstance.post(`/api/gcadmin/v1/router/listUsers?routerName=` + param.routerName, param).then(res => res.data);
    } catch (error) {
        throw error;
    }
}
export const createRouterUser = param => {
    try {
        return axiosInstance.post(`/api/gcadmin/v1/router/createUser?routerName=` + param.routerName + `&userName=` + param.userName + `&userPass=` + param.userPass, param).then(res => res.data);
    } catch (error) {
        throw error;
    }
}
export const deleteRouterUser = param => {
    try {
        return axiosInstance.post(`/api/gcadmin/v1/router/deleteUser?routerName=` + param.routerName + `&userName=` + param.userName).then(res => res.data);
    } catch (error) {
        throw error;
    }
}
